var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBurger = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.928572 0C0.415736 0 0 0.415735 0 0.928571C0 1.44141 0.415736 1.85714 0.928572 1.85714H16.0714C16.5843 1.85714 17 1.44141 17 0.928571C17 0.415735 16.5843 0 16.0714 0H0.928572ZM0 4.64286C0 5.15569 0.415736 5.57143 0.928572 5.57143H16.0714C16.5843 5.57143 17 5.15569 17 4.64286C17 4.13002 16.5843 3.71429 16.0714 3.71429H0.928572C0.415736 3.71429 0 4.13002 0 4.64286ZM0 12.0714C0 12.5843 0.415736 13 0.928572 13H16.0714C16.5843 13 17 12.5843 17 12.0714C17 11.5586 16.5843 11.1429 16.0714 11.1429H0.928572C0.415736 11.1429 0 11.5586 0 12.0714ZM0 8.35714C0 8.86998 0.415736 9.28571 0.928572 9.28571H16.0714C16.5843 9.28571 17 8.86998 17 8.35714C17 7.84431 16.5843 7.42857 16.0714 7.42857H0.928572C0.415736 7.42857 0 7.84431 0 8.35714Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Burger.b24041f3.svg";
export { ForwardRef as ReactComponent };